module.exports = __webpack_public_path__ + "img/eu-pass.2a66ba4.jpg";